<div class="modal fade show d-block" tabindex="-1" role="dialog" (click)="onBackdropClick($event)">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content rounded-4 shadow border-0">
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title d-flex align-items-center gap-2">
                    <span class="material-symbols-outlined text-colonial">store</span>
                    {{ isEditMode ? 'Editar' : 'Nueva' }} Sucursal
                </h5>
                <button type="button" class="btn-close" (click)="onCancel()"></button>
            </div>

            <div class="modal-body">
                <form [formGroup]="form">
                    <!-- Branch Name -->
                    <div class="mb-3">
                        <label for="branchName" class="form-label">Nombre de la Sucursal <span
                                class="text-danger">*</span></label>
                        <input type="text" class="form-control" id="branchName" formControlName="name"
                            placeholder="Ej: Sucursal Centro">
                    </div>

                    <!-- Region -->
                    <div class="mb-3" *ngIf="regions.length > 0">
                        <label for="branchRegion" class="form-label">Región</label>
                        <select id="branchRegion" class="form-select" formControlName="regionId">
                            <option [ngValue]="null">Sin región</option>
                            <option *ngFor="let region of regions" [ngValue]="region.id">{{ region.name }}</option>
                        </select>
                    </div>

                    <!-- Places Search -->
                    <div class="mb-3">
                        <label for="placeSearch" class="form-label">Buscar Ubicación</label>
                        <div class="input-group">
                            <span class="input-group-text">
                                <span class="material-symbols-outlined" style="font-size: 18px;">search</span>
                            </span>
                            <input type="text" class="form-control" id="placeSearch" #searchInput
                                placeholder="Buscar dirección o lugar...">
                        </div>
                        <small class="text-muted">Busca un lugar o arrastra el marcador en el mapa</small>
                    </div>

                    <!-- Google Map -->
                    <div class="mb-3 rounded-3 overflow-hidden border" style="height: 300px;">
                        <google-map height="300px" width="100%" [center]="center" [zoom]="zoom" [options]="mapOptions">
                            <map-marker [position]="markerPosition" [options]="markerOptions"
                                (mapDragend)="onMarkerDragEnd($event)">
                            </map-marker>
                        </google-map>
                    </div>

                    <!-- Coordinates Display (Hidden) -->
                    <div class="row g-3 d-none">
                        <div class="col-6">
                            <label class="form-label">Latitud</label>
                            <input type="number" class="form-control bg-light" formControlName="latitude" readonly>
                        </div>
                        <div class="col-6">
                            <label class="form-label">Longitud</label>
                            <input type="number" class="form-control bg-light" formControlName="longitude" readonly>
                        </div>
                    </div>
                </form>
            </div>

            <div class="modal-footer border-0">
                <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Cancelar</button>
                <button type="button" class="btn bg-colonial btn-secondary" (click)="onSave()"
                    [disabled]="form.invalid">
                    {{ isEditMode ? 'Actualizar' : 'Agregar' }} Sucursal
                </button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade show"></div>